import { getFlightSegmentsState } from 'selectors/flightsSelectors'
import type { AppAction } from './types/ActionTypes'
import { updateSearchString } from './NavigationActions'
import { encodeCostWithInsurance } from 'lib/insurance/insuranceUtils'
import buildPointsKey from 'loyalty/lib/pointsCalculation/buildPointsKey'
import { nonNullable } from 'lib/array/arrayUtils'

export function goToNextFlightSearchStep(params: {
  journeyId: string
  fareFamilyId?: string
  fareFamiliesKey?: string
  pointsCalculationRequests?: Array<App.LoyaltyPointsEarnCalculationRequest | undefined>
  costWithInsurance?: App.FlightFareFamily['costWithInsurance']
}): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { segmentsData, activeSegmentIndex } = getFlightSegmentsState(state)
    const customerId = state.auth.account.memberId ?? ''
    const filteredPointsCalculationRequests = params.pointsCalculationRequests ? nonNullable(params.pointsCalculationRequests) : []
    const loyaltyPointsKeys = filteredPointsCalculationRequests.map((request) => buildPointsKey(request, customerId))

    dispatch(updateSearchString({
      activeSegmentIndex: activeSegmentIndex + 1,
      segmentsData: [...segmentsData, {
        journeyId: params.journeyId,
        fareFamilyId: params.fareFamilyId,
        fareFamiliesKey: params.fareFamiliesKey,
        loyaltyPointsKeys,
        ...(params.costWithInsurance && { insurance: encodeCostWithInsurance(params.costWithInsurance) }),
      }],
    }))
  }
}

export function editFlightsFromPreviousSegment(segmentIndexToEdit: number): AppAction {
  return (dispatch, getState) => {
    if (segmentIndexToEdit === 0) {
      dispatch(updateSearchString({
        activeSegmentIndex: undefined,
        segmentsData: undefined,
      }))
      return
    }

    const state = getState()
    const { segmentsData } = getFlightSegmentsState(state)

    dispatch(updateSearchString({
      activeSegmentIndex: segmentIndexToEdit,
      segmentsData: segmentsData.slice(0, segmentIndexToEdit),
    }))
  }
}
